import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Account, ClientData, PortfolioElement } from '../user-profile-details/client-data';
import Swal from 'sweetalert2';
import { RequestService } from 'src/app/services/request.service';
import { ApiService } from 'src/app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { RequestSentModalComponent } from '../request-sent-modal/request-sent-modal.component';
import { Router } from '@angular/router';

interface EmailChangeRequest {
  MainCode: number;
  RelationCode: string;
  Contact: string;
  Verified: boolean;
}

@Component({
  selector: 'app-request-email-change',
  templateUrl: './request-email-change.component.html',
  styleUrls: ['./request-email-change.component.scss']
})
export class RequestEmailChangeComponent implements OnInit {
   isSubmitting = false;
    @Input() selectedAccount: Account;
    titleMessage: string;
    textConfirmMassage: string;
    submitStatus;
    newEmailChange: EmailChangeRequest = {} as EmailChangeRequest;
    today = new Date();
    userPortfolio: ClientData;
    userAccounts: Account[];
    companyName: string;
    clientStocks: PortfolioElement[] = [];
    departments: any[] = [];
    selectedAccountControl = new FormControl(null, Validators.required);
    isDialogOpen: any;
    accountList: Account[];
    newEmail: string;
    @ViewChild('EmailChangeForm') EmailChangeForm : NgForm; 
  
    lang: string;

  constructor(
    public translate: TranslateService,
    private requestService: RequestService,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,

    
  ) { 
    this.lang = this.translate.currentLang}




    ngOnInit(): void {
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }

  fetchUserPortfolio(selectedAcc?) {
    if (selectedAcc) this.selectedAccount = selectedAcc;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.clientStocks = res.Portfolio.EGPPortfolio?.Portfolio as PortfolioElement[];
        });
    }
  }


  clientSelected(e: Account) {
       
    this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccountControl.setValue(null);


  }


  onAccountChange(relationCode: string) {
    if (!this.userAccounts) {
      return;
    }
  
    const selectedAcc = this.userAccounts.find(acc => acc.relationCode === relationCode);
    if (selectedAcc) {
      this.selectedAccount = selectedAcc; 
      this.fetchUserPortfolio(selectedAcc); 
    }
  }
  

  submitChangeEmailRequest(form: NgForm) {
    if (form && form.valid) {
      this.newEmailChange.RelationCode = this.selectedAccount.relationCode;
      this.newEmailChange.Verified = true;
      this.newEmailChange.Contact= this.newEmail;

      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد الطلب";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل الإرسال 
      الحساب: ${this.selectedAccount.clientNameAr}
      البريد الإلكترونى:${this.newEmailChange.Contact}
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Coupon Confirmation";
        this.textConfirmMassage = `Please check The Information Before Sending The Coupon Collection
     Account: ${this.selectedAccount.clientNameEn}
     New Email : ${this.newEmailChange.Contact}
    
     `;
      }
      
      Swal.fire({
          customClass: {
    popup: 'lg-pop-width'
  },
        title: this.titleMessage,
        html:
             "<pre>" +
    this.textConfirmMassage +  this.translate.instant("order-rel-code") +" : " + 
    
    "</pre><p>" ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.submitEmailChangeRequest(this.newEmailChange).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);

            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);

            }
          );
        } else if (!result.isConfirmed) {
          this.isSubmitting = false;
        }
      });
    }
  }


       
    public resetStepper(): void {
    // Reset variables
    this.selectedAccount = null;
    this.EmailChangeForm?.reset();

  }

  
}
